import { listMetricLabels } from "features/analytics/services/analyticsLabelService";
import { useGlobalSharedState } from "Hooks/useSharedState";
import { useMemo } from "react";

const fetchMetricLabels = async () => {
  let res = await listMetricLabels();
  return res;
};


export const useMetricLabels = () => {
  const { state, setState, loading } = useGlobalSharedState(
    "metricLabels",
    [],
    fetchMetricLabels
  );

  const visibleMetricLabels = useMemo(() => {
    return state.filter((l) => !l.hidden);
  }, [state]);

  return {
    metricLabels: visibleMetricLabels,
    allMetricLabels: state,
    setMetricLables: setState,
    loading,
  };
};
